import React, { useContext, useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../Header.css';
import 'react-datepicker/dist/react-datepicker.css';
import { FaSearch, FaChevronLeft, FaChevronRight, FaSlidersH } from "react-icons/fa";
import { ApiService } from '../Services/apiServices';
import Skeleton from 'react-loading-skeleton';
import { WishlistContext } from '../Context/WishlistContext';



const suggestions = [
    { name: "Nearby", description: "Find what’s around you", icon: "fa-location-arrow" },
    { name: "Jaipur", description: "Great for a weekend getaway", icon: "fa-landmark" },
    { name: "Malviya Nagar", description: "Near you", icon: "fa-city" },
    { name: "City Palace", description: "For history lovers", icon: "fa-mountain" },
    { name: "Amer", description: "For nature lovers", icon: "fa-mountain" },

];

const Header = () => {
    const location = useLocation();
    const [isScrolled, setIsScrolled] = useState(false);
    const [showSearchBar, setShowSearchBar] = useState(true);
    const [isSearchOpen, setSearchOpen] = useState(false);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const searchRef = useRef(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [category, setCategory] = useState([]);
    const navigate = useNavigate();

    const { wishlist, setWishlist, handleRemoveFromWishlist } = useContext(WishlistContext);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setIsScrolled(true);
                setShowSearchBar(false);

            } else {
                setIsScrolled(false);
                setShowSearchBar(true);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    useEffect(() => {
        if (isScrolled) {
            setShowSuggestions(false);
        }
    }, [isScrolled]);

    const handleSearch = () => {
        if (searchQuery.trim() !== "") {
            setShowSuggestions(false);
            setSearchOpen(false);
            navigate(`/searchresult?search=${encodeURIComponent(searchQuery)}`);
        }
    };

    // Close suggestions when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setShowSuggestions(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const getLocation = (shouldNavigate = true) => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    const { latitude, longitude } = position.coords;
                    try {
                        const response = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`);
                        const data = await response.json();

                        // Extract more useful short name
                        const suburb = data?.address?.suburb || "";
                        const city = data?.address?.city || data?.address?.town || data?.address?.village || "";
                        const state = data?.address?.state || "";

                        // Combine parts to something like "Sector 28, Gurgaon"
                        const cleanLocation = `${suburb}, ${city}`.replace(/^, |, $/g, '').trim();

                        console.log("Cleaned Location:", cleanLocation);

                        setSearchQuery(cleanLocation);
                        setShowSuggestions(false);
                        setSearchOpen(true);
                        if (shouldNavigate) {
                            navigate(`/searchresult?query=${encodeURIComponent(cleanLocation)}`);
                        }
                    } catch (error) {
                        console.error("Error fetching location name:", error);
                        alert("Could not fetch location. Please try again.");
                    }
                },
                (error) => {
                    console.error("Geolocation error:", error);
                    alert("Location access denied. Please enable location services.");
                }
            );
        } else {
            alert("Geolocation is not supported by this browser.");
        }
    };


    useEffect(() => {
        const fetchtcategory = async () => {
            try {
                setLoading(true);
                const categoryData = await ApiService.Commanfetchrequest('categories');
                setCategory(categoryData);
                // console.log('category data:', categoryData);
            } catch (error) {
                console.log('error while fetching:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchtcategory();
    }, []);





    return (
        <>
            <div className={`container-fluid px-3 ${isScrolled ? "fixed-header" : ""}`}>
                <div className="d-flex align-items-center justify-content-between py-2">
                    {/* Left - Logo */}
                    <Link to="/" className="navbar-brand">
                        <h1 className="m-0" style={{ color: "green", fontWeight: "700" }}>{'FamilyFun'}</h1>
                    </Link>

                    <div className="center-nav">
                        <Link to="/" className={`nav-link ${location.pathname === "/" ? "active" : ""}`}>Home</Link>
                        <Link to="/" className={`nav-link ${location.pathname === "/rooms" ? "active" : ""}`}>Experience</Link>
                    </div>

                    {/* Right - User Icon & Navbar Toggler */}
                    <div className="d-md-flex d-flex align-items-center bg-white rounded-pill shadow-sm p-2 gap-2">
                        {/* Navbar Toggler */}
                        <button className="border-0 bg-transparent p-2 rounded-circle"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#togglerOffcanvas"
                            aria-controls="togglerOffcanvas"
                            data-bs-backdrop="false"
                            data-bs-scroll="true"
                        >
                            <i className="fa fa-bars"></i> {/* FontAwesome Icon */}
                        </button>

                        <button className="text-dark border-0 bg-transparent d-flex align-items-center justify-content-center rounded-circle user-icon"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#wishlistOffcanvas"
                            aria-controls="wishlistOffcanvas"
                            data-bs-backdrop="false"
                            data-bs-scroll="true"
                        >
                            <i className="fa fa-heart fs-4"></i>
                        </button>
                    </div>
                </div>

                {/* Mobile Search Box */}
                <div className="mobile-search" onClick={() => setSearchOpen(true)}>
                    <FaSearch className="search-icon" />
                    <span>Search destinations</span>
                </div>

                {isSearchOpen && (
                    <div className="expanded-search">
                        {/* Close Button */}
                        <button onClick={() => setSearchOpen(false)} className="close-btn">✖</button>

                        {/* Search Input */}
                        <div className="search-bar mb-4">
                            <div className="search-item">
                                <h6>Where</h6>
                                <input
                                    type="text"
                                    placeholder="Search destinations"
                                    className="search-input text-center"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    onFocus={() => setShowSuggestions(true)}
                                    style={{ border: "none", outline: "none", background: "transparent", alignItems: "center" }}
                                />
                            </div>
                            <div className="search-divider"></div>
                            <button className="search-button" type='button' onClick={handleSearch}>
                                <i className="fa fa-search"></i>
                            </button>

                        </div>

                        {/* Suggested Destinations */}
                        <div className="search-suggestions">
                            <h6 className="suggestions-title">Suggested destinations</h6>
                            {suggestions.map((item, index) => (
                                <div key={index} className="suggestion-item"
                                    onClick={async () => {
                                        if (item.name === "Nearby") {
                                            getLocation(false); // Don't navigate inside getLocation
                                        } else {
                                            setSearchQuery(item.name);
                                            setShowSuggestions(true);
                                            setSearchOpen(true);
                                        }
                                    }}

                                >
                                    <i className={`fa ${item.icon} suggestion-icon`}></i>
                                    <div>
                                        <div className="suggestion-name">{item.name}</div>
                                        <div className="suggestion-description">{item.description}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}


                {/* Room Search Bar - Moves Up on Scroll */}
                <div className={`search-bar-container ${isScrolled ? "scrolled-search-bar" : ""}`} ref={searchRef}>
                    <div className="search-bar mt-1">
                        <div className="search-item">
                            <h6>Where</h6>
                            <input
                                type="text"
                                placeholder="Search destinations"
                                className="search-input text-center"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                onFocus={() => setShowSuggestions(true)}
                                style={{ border: "none", outline: "none", background: "transparent" }}
                            />
                        </div>
                        <div className="search-divider"></div>
                        <button className="search-button" type='button' onClick={handleSearch}>
                            <i className="fa fa-search"></i>
                        </button>

                    </div>

                    {/* Suggested Search Modal */}
                    {showSuggestions && (
                        <div className="search-suggestions">
                            <h6 className="suggestions-title">Suggested destinations</h6>
                            {suggestions.map((item, index) => (
                                <div key={index} className="suggestion-item"
                                    onClick={async () => {
                                        if (item.name === "Nearby") {
                                            getLocation(false); // Don't navigate inside getLocation
                                        } else {
                                            setSearchQuery(item.name);
                                            setShowSuggestions(true);
                                            setSearchOpen(true);
                                        }
                                    }}

                                >
                                    <i className={`fa ${item.icon} suggestion-icon`}></i>
                                    <div>
                                        <div className="suggestion-name">{item.name}</div>
                                        <div className="suggestion-description">{item.description}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            <hr />

            <div className="offcanvas offcanvas-end custom-offcanvas" data-bs-backdrop="false" tabindex="-1" id="togglerOffcanvas" aria-labelledby="togglerOffcanvasLabel">
                <div className="offcanvas-header">
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <h5
                            id="togglerOffcanvasLabel"
                            style={{
                                color: "green",
                                fontSize: "16px",
                                fontWeight: "600",
                                marginLeft: "50px"
                            }}
                        >
                            Search by Category
                        </h5>
                    </div>

                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <hr />
                <div className="offcanvas-body">
                    <div className="category-container">
                        {loading
                            ? Array.from({ length: 6 }).map((_, index) => (
                                <div key={index} className="category-item">
                                    <Skeleton
                                        circle={true}
                                        width={40}
                                        height={40}
                                        style={{ marginBottom: '10px' }}
                                    />
                                    <span><Skeleton width={80} height={20} /></span>
                                </div>
                            ))
                            : category.map((cat, index) => (
                                <Link key={index} to={`/category/${cat.url}`} style={{ textDecoration: "none" }}>
                                    <div className="category-item">
                                        {cat.category_image && (
                                            <img
                                                src={`https://www.adminfamilyfun.jewelscraze.com/front/images/categories/${cat.category_image}`}
                                                alt={cat.category_name}
                                                className="category-image"
                                                style={{ width: "30px", height: "30px" }}
                                                loading="lazy"
                                            />
                                        )}
                                        <br />
                                        <span>{cat.category_name}</span>
                                    </div>
                                </Link>
                            ))}
                    </div>
                </div>
            </div>

            <div className="offcanvas offcanvas-end custom-offcanvas" data-bs-backdrop="false" tabIndex="-1" id="wishlistOffcanvas" aria-labelledby="wishlistOffcanvasLabel">
                <div className="offcanvas-header">
                    <h5 id="wishlistOffcanvasLabel" style={{ color: "green", fontWeight: "600", fontSize: "16px", marginLeft: "50px" }}>
                        Your Wishlist Items
                    </h5>
                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <hr />
                <div className="offcanvas-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                    {wishlist.length === 0 ? (
                        <div className='text-center'>
                            <p>No items in your wishlist.</p>
                        </div>


                    ) : (
                        wishlist.map((item, index) => (
                            <div key={index} className="wishlist-item mb-3 p-2 border rounded">
                                <div className="d-flex align-items-start">
                                    <img
                                        src={`https://www.adminfamilyfun.jewelscraze.com/front/images/rooms/${item.room_images?.[0]?.room_images || "default.jpg"}`}
                                        alt={item.room_name}
                                        style={{ width: "80px", height: "80px", objectFit: "cover", borderRadius: "8px", marginRight: "10px" }}
                                    />
                                    <div className="flex-grow-1">
                                        <h6 className="mb-1">{item.room_name}</h6>
                                        <p className="mb-1" style={{ fontSize: "14px" }}>{item.location}</p>
                                        <p className="mb-2" style={{ fontSize: "14px", fontWeight: "bold" }}>⭐ {item.rating || "4.9"}</p>
                                        <div className="d-flex gap-2">
                                            <Link to={`/property-details/${item.room_name}`} className="btn btn-sm btn-primary">
                                                View
                                            </Link>
                                            <button className="btn btn-sm btn-danger" onClick={() => handleRemoveFromWishlist(item.room_name)}>
                                                Remove
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>



        </>
    );
};

export default Header;
